import { AfterViewInit, Component, EventEmitter, Input, input, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { GinfoKeyDatesVm, GinfoProjectDetailsVm, ProjectStatus, ProjectVm, KeyDatesDto } from '../../../models/project-vm';
import moment from 'moment';
import { DatePipe } from '@angular/common';
import { ProjectApproval } from '../../../models/salesplan-vm';
import { ProjectService } from '../../../services/project.service';
import { MessageService } from '../../../services/message.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UserLogin } from '../../../../Common/models/user.login';
import { StorageService } from '../../../../Common/services/storage.service';
import { RefTypeEnum } from '../../../enums/ref-type-enum';
import { UserRoleServiceService } from '../../../../shared/services/user-role-service.service';
import { UnsavedChangesService } from '../../../../unsaved-changes.service';

@Component({
  selector: 'app-ginfo-key-dates',
  templateUrl: './ginfo-key-dates.component.html',
  styleUrl: './ginfo-key-dates.component.css'
})
export class GinfoKeyDatesComponent implements AfterViewInit {
  date = new FormControl();
  resourceFulfilledDate: any;
  dateFormat: string | undefined;

  @Input() keyDatesInfo: GinfoKeyDatesVm = new GinfoKeyDatesVm();
  @Input() projectApporval: ProjectApproval = new ProjectApproval();
  @Input() selProjectStatus: ProjectStatus = new ProjectStatus();
  @Input() componentUsedBy: RefTypeEnum = RefTypeEnum.None;
  @Input() enablePWR: boolean = false;
  @Input() isSRETeam: boolean = false;
  @Input() projectId: number = 0;
  @Input() disableAfterReview: boolean = false;
  @Input() disableAll: boolean = false;
  @Output() emitValueChanged = new EventEmitter<GinfoKeyDatesVm>();
  @Output() notifyExecutionProcess = new EventEmitter<number>();
  weeksToAdd: number = 2; // Default to 2 weeks 

  endDate: Date | null | undefined;
  //submDate: Date | null | undefined;
  //ldDate: Date | null | undefined;
  today: Date | null | undefined;
  execSD: Date | null | undefined;

  minDateForStartDate: Date | null | undefined;
  minDateForEndDate: Date | null | undefined;
  minDateForExecStartDate: Date | null | undefined;

  submRevDate: Date | null | undefined;
  uInfo: UserLogin | null | undefined;
  canAccessExecStart: boolean = false;
  canAccessExecEnd: boolean = false;
  disableExecStart: boolean = false;
  disableExecEnd: boolean = false;

  constructor(private projectService: ProjectService,
    private msgService: MessageService,
    private ngxService: NgxUiLoaderService,
    private storageService: StorageService,
    private userRoleService: UserRoleServiceService,
    private unsavedChangesService: UnsavedChangesService
  ) { }

  async ngOnInit() {

    this.uInfo = this.storageService.getItem<UserLogin>("UserInfo");

    this.today = new Date();

    this.setInitiatedDate();

    this.setMinDateForStartDate();
    
    this.setStartDate();
    
    await this.setEndDate();

    this.setMinDateForExecStartDate();

  }

  ngAfterViewInit(): void {
  }

  setInitiatedDate() {
    if (this.keyDatesInfo!.initiatedDate) {
      this.keyDatesInfo!.initiatedDate = new Date(this.keyDatesInfo!.initiatedDate);
    } else {
      this.keyDatesInfo!.initiatedDate = new Date(); // Default to today if null
    }
    
    this.keyDatesInfo.initiatedDateStr = moment(this.keyDatesInfo.initiatedDate).format('DD-MMM-yyyy');
  }

  setStartDate() {
    if (this.keyDatesInfo.startDate) {
    } else {
      this.keyDatesInfo.startDate = this.getFutureSunday();
    }

    const momentDate = moment(this.keyDatesInfo.startDate, 'YYYY-MM-DD').toDate();
    this.keyDatesInfo.startDate = momentDate;

    this.keyDatesInfo.startDateStr = moment(this.keyDatesInfo.startDate).format('DD-MMM-yyyy');

    this.setMinDateForExecStartDate();
  }

  setMinDateForStartDate() {
    if (this.isSRETeam) {
      this.minDateForStartDate = this.keyDatesInfo.initiatedDate;
    }
    else {
      this.minDateForStartDate = this.getFutureSunday();
    }
  }

  setMinDateForEndDate(startDate: any){
    this.minDateForEndDate = startDate;
  }

  setMinDateForExecStartDate(){
    this.minDateForExecStartDate = this.keyDatesInfo.startDate!;
  }

  async ngOnChanges(changes: SimpleChanges) {

    if (changes['selProjectStatus'] && this.selProjectStatus! != null) {
      this.canAccessExecStart = await this.userRoleService.canAccessExecutionStart();
      this.canAccessExecEnd = await this.userRoleService.canAccessExecutionEnd();

      if (this.selProjectStatus.statusID == 3 && this.canAccessExecStart) {
        this.disableExecStart = true;
      }

      if (this.selProjectStatus.statusID == 4 && this.canAccessExecEnd) {
        this.disableExecEnd = true;
      }
    }

    if (changes['keyDatesInfo'] && this.keyDatesInfo! != null) {

      if (this.projectApporval! != null) {
        if (this.projectApporval!.isReviewClicked! || this.projectApporval!.isApproveClicked!) {
          this.submRevDate = this.keyDatesInfo.submittedDate;
        }
      }
      //else this.submDate = null;

      if (this.keyDatesInfo!.pwrDate != null) {
        this.keyDatesInfo!.pwrDate = new Date(this.keyDatesInfo!.pwrDate!);
        this.keyDatesInfo.pwrDateStr = moment(this.keyDatesInfo!.pwrDate).format('DD-MMM-yyyy');
      }

      if (this.keyDatesInfo!.executionStart != null) {
        this.keyDatesInfo!.executionStart = new Date(this.keyDatesInfo!.executionStart!);
        this.execSD = this.keyDatesInfo!.executionStart;
      }
      else {
        this.execSD = new Date();
      }

      if (this.keyDatesInfo!.executionEnd != null) {
        this.keyDatesInfo!.executionEnd = new Date(this.keyDatesInfo!.executionEnd!);
      }
      else {
      }

      this.setInitiatedDate();

      this.setMinDateForStartDate();

      this.setStartDate();

      // Calculate the end date based on the start date
      await this.setEndDate();

      this.emitValueChanged.emit(this.keyDatesInfo);
    }
  }

  async onStartDateChange(ev: any) {
    this.keyDatesInfo.startDateStr = moment(ev).format('DD-MMM-yyyy');

    this.endDate = new Date(ev); // Clone start date
    this.endDate.setDate(this.endDate.getDate() + (7 * 2)); // Add weeksToAdd weeks
    this.keyDatesInfo.endDate = this.endDate;
    this.keyDatesInfo.endDateStr = moment(this.endDate).format('DD-MMM-yyyy');

    this.setMinDateForEndDate(ev); //For All roles
    this.setMinDateForExecStartDate();
    this.unsavedChangesService.setUnsavedChanges(true);
    this.emitValueChanged.emit(this.keyDatesInfo);
  }

  async setEndDate() {
    if (this.keyDatesInfo.startDate) {
      // Clone to avoid modifying the original
      let selectedStartDate = new Date(this.keyDatesInfo.startDate);

      // Create a new Date object for adjusting
      const tWOWeeksLater = new Date(selectedStartDate);
      tWOWeeksLater.setDate(selectedStartDate.getDate() + (7 * 2)); // Adjusting the date by 14 days

      this.setMinDateForEndDate(this.keyDatesInfo.initiatedDate); //For All roles

      // Set the end date in the keyDatesInfo
      if (!this.keyDatesInfo.endDate) {
        this.keyDatesInfo.endDate = tWOWeeksLater;
      }
      const momentEndDate = moment(this.keyDatesInfo.endDate, 'YYYY-MM-DD').toDate();
      this.keyDatesInfo.endDate = momentEndDate;
      this.keyDatesInfo.endDateStr = moment(this.keyDatesInfo.endDate).format('DD-MMM-yyyy');
      this.emitValueChanged.emit(this.keyDatesInfo);
    }
  }

  onEndDateChange(ev: any) {
    this.keyDatesInfo.endDate = ev;
    this.keyDatesInfo.endDateStr = moment(ev).format('DD-MMM-yyyy');
    this.unsavedChangesService.setUnsavedChanges(true);
    this.emitValueChanged.emit(this.keyDatesInfo);
  }

  onPWRDateChange(ev: any) {
    this.keyDatesInfo.pwrDate = ev;
    this.keyDatesInfo.pwrDateStr = moment(ev).format('DD-MMM-yyyy');
    this.unsavedChangesService.setUnsavedChanges(true);
    this.emitValueChanged.emit(this.keyDatesInfo);
  }

  onExecutionStartChange(ev: any) {
    this.keyDatesInfo.executionStart = ev;
    this.keyDatesInfo.executionStartStr = moment(ev).format('DD-MMM-yyyy');
    this.unsavedChangesService.setUnsavedChanges(true);
  }

  onExecutionEndChange(ev: any) {
    this.keyDatesInfo.executionEnd = ev;
    this.keyDatesInfo.executionEndStr = moment(ev).format('DD-MMM-yyyy');
    this.unsavedChangesService.setUnsavedChanges(true);
  }

  onExecutionStartClick() {
    if (this.keyDatesInfo.executionStartStr != null
      && this.keyDatesInfo.executionStartStr != undefined
      && this.keyDatesInfo.executionStartStr.length > 0
    ) {
      let proectDetails: ProjectVm = new ProjectVm();

      proectDetails.generalInfo.projectDetails = new GinfoProjectDetailsVm();
      proectDetails.generalInfo.projectDetails.projectId = this.projectId!;

      proectDetails.generalInfo.keyDates = this.keyDatesInfo;
      proectDetails.generalInfo.keyDates.isExecutionStart = true;
      proectDetails.generalInfo.keyDates.isExecutionComplete = false;

      proectDetails.projectStatus = new ProjectStatus();
      proectDetails.projectStatus.changedBy! = this.uInfo!.userID;
      proectDetails.projectStatus.changedDate! = new Date();
      proectDetails.projectStatus.refID! = this.projectId!;
      proectDetails.projectStatus.statusID! = 4;
      proectDetails.projectStatus.type! = this.componentUsedBy;

      this.ngxService.start();
      this.projectService.SaveUpdateExecutionProcess(proectDetails).subscribe({
        next: (projectId) => {
          // handle value
          this.msgService.htmlSuccess("Execution Start process completed successfully");
          this.ngxService.stop();

          this.notifyExecutionProcess.emit(projectId);
        },
        error: (error) => {
          this.ngxService.stop();
          // handle error
          //this.msgService.htmlError(error.message);
        },
        complete: () => {
          // handle complete
        }
      });
    }
    else {
      this.msgService.htmlError("Execution Start date is required");
    }
  }

  onExecutionCompletedClick() {
    if (this.keyDatesInfo.executionEndStr != null
      && this.keyDatesInfo.executionEndStr != undefined
      && this.keyDatesInfo.executionEndStr.length > 0
    ) {
      let proectDetails: ProjectVm = new ProjectVm();

      proectDetails.generalInfo.projectDetails = new GinfoProjectDetailsVm();
      proectDetails.generalInfo.projectDetails.projectId = this.projectId!;

      proectDetails.generalInfo.keyDates = this.keyDatesInfo;
      proectDetails.generalInfo.keyDates.isExecutionStart = false;
      proectDetails.generalInfo.keyDates.isExecutionComplete = true;

      proectDetails.projectStatus = new ProjectStatus();
      proectDetails.projectStatus.changedBy! = this.uInfo!.userID;
      proectDetails.projectStatus.changedDate! = new Date();
      proectDetails.projectStatus.refID! = this.projectId!;
      proectDetails.projectStatus.statusID! = 5;
      proectDetails.projectStatus.type! = this.componentUsedBy;

      this.ngxService.start();
      this.projectService.SaveUpdateExecutionProcess(proectDetails).subscribe({
        next: (projectId) => {
          // handle value
          this.msgService.htmlSuccess("Execution Completed process completed successfully");
          this.ngxService.stop();

          this.notifyExecutionProcess.emit(projectId);
          this.unsavedChangesService.setUnsavedChanges(false);
        },
        error: (error) => {
          this.ngxService.stop();
        },
        complete: () => {
         
        }
      });
    }
    else {
      this.msgService.htmlError("Execution End date is required");
    }
  }

  getFutureSunday(): Date {
    const baseDate = this.keyDatesInfo.initiatedDate ? new Date(this.keyDatesInfo.initiatedDate) : new Date();
    
    const threeWeeksLater = new Date(baseDate);
    threeWeeksLater.setDate(baseDate.getDate() + 21); // Add 21 days (3 weeks)

    // Find the immediate Sunday after three weeks later
    const dayOfWeek = threeWeeksLater.getDay();
    const daysUntilSunday = (7 - dayOfWeek) % 7;
    const nextSunday = new Date(threeWeeksLater);
    nextSunday.setDate(threeWeeksLater.getDate() + daysUntilSunday);

    return nextSunday;
  }

  //// Key dates calucation after review request
  async changeKeyDatesAfterReviewRequest(headerId: number) {
    this.getFutureSundayAfterReviewRequest(headerId);
  }

  getFutureSundayAfterReviewRequest(headerId: number) {
    const today = new Date();
    this.keyDatesInfo.initiatedDate = today;
  
    this.setMinDateForStartDate();
    this.setStartDate();
  
    this.setMinDateForExecStartDate();
    
    this.calculateEndDateAfterReviewRequest(headerId);
  }

  calculateEndDateAfterReviewRequest(headerId: number) {

    if (this.keyDatesInfo.startDate) {

      let keyDatesDto = new KeyDatesDto();
      keyDatesDto.headerId = headerId;
      keyDatesDto.startDate = this.keyDatesInfo.startDate;     
      keyDatesDto.startDateStr = moment(this.keyDatesInfo.startDate).format('DD-MMM-yyyy'); //Pass as string to fix time zone conversion issue // It saves the previous date value
      keyDatesDto.initiatedDate = this.keyDatesInfo.initiatedDate ?? undefined;
      keyDatesDto.initiatedDateStr = moment(keyDatesDto.initiatedDate).format('DD-MMM-yyyy');

      let newEndDate: Date | null | undefined;
      newEndDate = new Date(this.keyDatesInfo.startDate); // Clone start date
      newEndDate.setDate(newEndDate.getDate() + (7 * 2)); // Add weeksToAdd weeks

      const endDateOnly = this.getDateOnly(this.keyDatesInfo.endDate!);
      const newEndDateOnly = this.getDateOnly(newEndDate);

      if (this.keyDatesInfo.endDate === undefined || this.keyDatesInfo.endDate === null || endDateOnly.getTime() === newEndDateOnly.getTime()) {
        this.endDate = new Date(this.keyDatesInfo.startDate); // Clone start date
        this.endDate.setDate(this.endDate.getDate() + (7 * 2)); // Add weeksToAdd weeks

        this.keyDatesInfo.endDate = this.endDate;
        this.keyDatesInfo.endDateStr = moment(this.endDate).format('DD-MMM-yyyy');

        keyDatesDto.endDate = this.endDate ?? undefined;
        keyDatesDto.endDateStr = moment(keyDatesDto.endDate).format('DD-MMM-yyyy');
      }
      else {
        this.endDate = new Date(this.keyDatesInfo.endDate);
        this.endDate.setDate(this.endDate.getDate() + 0);

        this.keyDatesInfo.endDate = this.endDate;
        this.keyDatesInfo.endDateStr = moment(this.endDate).format('DD-MMM-yyyy');

        keyDatesDto.endDate = this.endDate ?? undefined;
        keyDatesDto.endDateStr = moment(keyDatesDto.endDate).format('DD-MMM-yyyy');
      }

      this.projectService.UpdateKeyDates(keyDatesDto).subscribe(x => {
      });
    }
  }

  getDateOnly(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

}